var _defs, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIterable = function SvgIterable(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: "100%",
      height: "100%",
      transform: "translate3d(0,0,0)"
    },
    viewBox: "0 0 363 214"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "iterable_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h363v214H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "iterable_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h600v600H0z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iterable_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#iterable_svg__b)",
    style: {
      display: "block"
    },
    transform: "translate(-118.5 -136)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "block"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333332",
    d: "M234.509 419.45h-28a.943.943 0 0 0-.943.943v49.234c0 .52.422.942.943.942h28a.94.94 0 0 0 .942-.942v-7.807a.945.945 0 0 0-.942-.943h-17.088c-.99 0-1.791-.803-1.791-1.792v-8.105c0-.99.801-1.793 1.791-1.793h15.663c.52 0 .943-.421.943-.942v-7.065a.946.946 0 0 0-.943-.942H217.42c-.99 0-1.791-.803-1.791-1.793v-7.51c0-.99.803-1.793 1.793-1.793h17.086a.94.94 0 0 0 .942-.943v-7.806a.945.945 0 0 0-.942-.943M350.642 470.57c.318 0 .603-.15.781-.41a.91.91 0 0 0 .097-.87l-19.703-49.252a.94.94 0 0 0-.873-.591h-5.049a.94.94 0 0 0-.878.59l-19.702 49.254a.91.91 0 0 0 .097.868c.178.26.463.41.78.41h8.981a.94.94 0 0 0 .882-.619l2.469-6.805a1.78 1.78 0 0 1 1.677-1.175h16.573c.756 0 1.43.476 1.682 1.189l2.402 6.785a.94.94 0 0 0 .884.625zm-16.87-18.138c-.336.47-.883.751-1.465.751H324.6c-.582 0-1.13-.281-1.465-.751a1.76 1.76 0 0 1-.225-1.618l3.829-10.695c.197-.553.624-1.024 1.19-1.177.98-.264 1.9.234 2.215 1.113l3.853 10.76c.194.54.11 1.146-.226 1.617M448.181 470.57a.943.943 0 0 0 .943-.943v-7.807a.94.94 0 0 0-.943-.942H433.62c-.99 0-1.793-.804-1.793-1.794v-38.69a.944.944 0 0 0-.943-.944h-8.177a.943.943 0 0 0-.943.944v49.233c0 .52.422.942.943.942zM368.801 470.57h19.29c3.324 0 6.212-.694 8.586-2.06 2.372-1.367 4.191-3.173 5.408-5.368a14.4 14.4 0 0 0 1.84-7.07c0-2.87-.701-5.43-2.086-7.604-1.364-2.14-3.266-3.83-5.649-5.021a.52.52 0 0 1-.281-.4l-.027-.226.203-.226c2.937-2.513 4.426-5.772 4.426-9.687 0-2.436-.57-4.702-1.692-6.734-1.119-2.022-2.847-3.662-5.136-4.878-2.301-1.224-5.156-1.846-8.486-1.846h-16.368c-.567 0-1.025.46-1.025 1.024v49.097c0 .551.447.998.997.998m9.066-39.889c0-.85.69-1.54 1.54-1.54h4.453c1.976 0 3.555.512 4.698 1.519.968.855 1.538 1.95 1.696 3.257.215 1.786-.415 3.553-1.685 4.727-1.197 1.108-2.807 1.669-4.784 1.669h-4.391a1.526 1.526 0 0 1-1.527-1.527zm0 19.514c0-.843.684-1.527 1.527-1.527h6.768c2.031 0 3.701.588 4.964 1.747 1.274 1.166 1.92 2.62 1.92 4.322 0 1.744-.632 3.233-1.876 4.426-1.24 1.187-2.925 1.788-5.008 1.788h-6.677a1.62 1.62 0 0 1-1.618-1.617zM281.478 452.882a1.774 1.774 0 0 1 .613-2.416c.835-.497 1.692-.967 2.389-1.644 3.506-3.402 5.294-7.687 5.294-12.572 0-2.88-.718-5.645-2.136-8.222-1.416-2.566-3.475-4.66-6.116-6.222-2.646-1.564-5.746-2.356-9.214-2.356h-15.57a.93.93 0 0 0-.932.932v49.256c0 .514.417.931.931.931h8.201a.93.93 0 0 0 .932-.931v-14.88a1.78 1.78 0 0 1 1.78-1.782h2.426c.663 0 1.272.368 1.58.955l8.443 16.138c.16.307.48.5.826.5h9.285a.92.92 0 0 0 .808-.468.92.92 0 0 0-.004-.933zm-4.169-11.492c-1.435 1.304-3.317 1.966-5.595 1.966h-4.064c-.984 0-1.78-.798-1.78-1.781v-10.65a1.78 1.78 0 0 1 1.78-1.782h4.064c2.276 0 4.16.676 5.598 2.007 1.445 1.34 2.176 3.057 2.176 5.1 0 2.096-.732 3.825-2.179 5.14M186.913 419.45h-32.188a.93.93 0 0 0-.928.928v7.837c0 .512.416.927.928.927h9.47c.982 0 1.778.796 1.778 1.778v38.721c0 .513.415.928.929.928h8.206a.93.93 0 0 0 .929-.928v-38.72c0-.983.796-1.78 1.778-1.78h9.098a.927.927 0 0 0 .928-.926v-7.837a.93.93 0 0 0-.928-.928M495.832 460.877H478.74c-.988 0-1.789-.801-1.789-1.789v-8.11c0-.989.801-1.79 1.79-1.79h15.667a.94.94 0 0 0 .939-.94v-7.07a.94.94 0 0 0-.94-.94H478.74a1.79 1.79 0 0 1-1.79-1.79v-7.516c0-.989.801-1.79 1.789-1.79h17.093a.94.94 0 0 0 .94-.94v-7.813c0-.519-.421-.939-.94-.939h-28.006a.94.94 0 0 0-.939.939v49.241c0 .518.42.938.939.938h28.006c.519 0 .94-.42.94-.939v-7.813a.94.94 0 0 0-.94-.94M134.536 460.93h-8.12a1.78 1.78 0 0 1-1.779-1.778h-.004v-28.128c0-.98.796-1.778 1.776-1.778h8.18a.93.93 0 0 0 .927-.928v-7.836a.93.93 0 0 0-.928-.928h-30.417a.93.93 0 0 0-.928.928v7.836c0 .511.416.928.928.928h8.619c.98 0 1.778.798 1.778 1.778v28.18a1.776 1.776 0 0 1-1.772 1.726h-8.598a.93.93 0 0 0-.928.928v7.837c0 .51.416.927.928.927h11.05c.08.024.16.05.25.05h8.206c.088 0 .168-.026.249-.05h10.583a.93.93 0 0 0 .928-.927v-7.837a.93.93 0 0 0-.928-.928"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      display: "block"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#67266D",
    strokeWidth: 45,
    d: "m235.803 263.077 63.707-65.94",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    style: {
      display: "block"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#58C1A8",
    strokeWidth: 45,
    d: "m364.52 261.992-64.832 64.832",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    style: {
      display: "block"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#EE3853",
    strokeWidth: 45,
    d: "m300.887 328.001-64.832-64.832",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.25,
    style: {
      display: "block"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#2DC3F3",
    strokeWidth: 45,
    d: "m299.537 197.32 64.832 64.833",
    opacity: 1
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#58C1A8",
    d: "M-22.732 0c0-12.555 10.177-22.731 22.731-22.731S22.731-12.555 22.731 0 12.553 22.731-.001 22.731-22.732 12.555-22.732 0",
    style: {
      display: "block"
    },
    transform: "rotate(179.98 149.793 163.499)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#67266D",
    d: "M.001-22.732c12.554 0 22.731 10.178 22.731 22.731 0 12.555-10.177 22.733-22.731 22.733S-22.732 12.554-22.732-.001c0-12.553 10.178-22.731 22.733-22.731",
    style: {
      display: "block"
    },
    transform: "rotate(-90 248.398 -51.108)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EE3853",
    d: "M0-22.732c12.555 0 22.731 10.178 22.731 22.732 0 12.555-10.176 22.732-22.731 22.732-12.554 0-22.731-10.177-22.731-22.732S-12.554-22.732 0-22.732",
    style: {
      display: "block"
    },
    transform: "rotate(-135 172.22 82.848)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DC3F3",
    d: "M-22.731 0c0-12.555 10.178-22.731 22.731-22.731 12.555 0 22.732 10.176 22.732 22.731S12.555 22.731 0 22.731c-12.553 0-22.731-10.176-22.731-22.731",
    style: {
      display: "block"
    },
    transform: "rotate(179.98 182.37 130.885)"
  }))));
};
export default SvgIterable;